import { FC, useState } from "react";
import { renderErrorMessage } from "../../../../components/messages/errorMessage";
import TaxDocCaseStore from "../../../../contexts/taxDocCaseStore";
import _t from "../../../../lang/translate";
import {
  adsDocumentationFileEndpoint,
  equipmentsDocumentationFileEndpoint,
  fetchEquipmentsDocumentationFile,
  newPriceDocumentationFileEndpoint,
  vehicleListDocumentationFileEndpoint,
} from "../../../../services/taxDocService";
import TaxDocUploadFile from "./taxDocUploadFile";

const TaxDocUploads: FC = () => {
  const { taxDocCase, setTaxDocCase } = TaxDocCaseStore.useContainer();
  const [loadingDat, setLoadingDat] = useState<boolean>(false);

  const handleAutoFetchDat = async () => {
    try {
      setLoadingDat(true);
      const { data } = await fetchEquipmentsDocumentationFile(taxDocCase.id);
      setTaxDocCase(data);
    } catch (error) {
      renderErrorMessage(error, _t("msg.file_not_removed"))
    } finally {
      setLoadingDat(false);
    }
  };

  return (
    <>
      <TaxDocUploadFile label={_t("ads")} fileKey="ads" action={adsDocumentationFileEndpoint(taxDocCase.id)} />
      <TaxDocUploadFile
        label={_t("vehicle_list_from_bilinfo")}
        fileKey="vehicleList"
        action={vehicleListDocumentationFileEndpoint(taxDocCase.id)}
      />
      <TaxDocUploadFile
        label={_t("newprice_documentation")}
        fileKey="newPrice"
        action={newPriceDocumentationFileEndpoint(taxDocCase.id)}
      />
      <TaxDocUploadFile
        label={_t("equipments_documentation")}
        fileKey="equipments"
        action={equipmentsDocumentationFileEndpoint(taxDocCase.id)}
        onAutoFetch={handleAutoFetchDat}
        loading={loadingDat}
      />
    </>
  );
};

export default TaxDocUploads;
